import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { apiUrl, fetchJson } from "@/lib/api";

/**
 * Slim urgency strip for the public landing page: shows how many of the 100
 * Founding Organization seats are still open. Renders nothing while loading,
 * on error, or once all seats are claimed, so it never shows a broken or
 * "0 left" state. Fed by the public, unauthenticated founding-stats endpoint.
 */
export default function FoundingSeatsBanner() {
  const [left, setLeft] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchJson(apiUrl("/api/accounts/public/founding-stats/"))
      .then((data) => {
        if (alive) setLeft(data?.orgs_left ?? null);
      })
      .catch(() => {
        if (alive) setLeft(null);
      });
    return () => {
      alive = false;
    };
  }, []);

  if (left === null || left <= 0) return null;

  return (
    <Link
      to="/get-started?a=business&c=1"
      className="block w-full no-underline"
      style={{
        background: "linear-gradient(90deg, #1a1a1a, #2b2b2b)",
        color: "#fff",
      }}
    >
      <div
        style={{ maxWidth: 1480, margin: "0 auto" }}
        className="px-6 lg:px-12 py-2.5 flex items-center justify-center gap-2.5 text-center text-sm sm:text-base"
      >
        <Award className="h-4 w-4 flex-shrink-0" style={{ color: "#ffd766" }} aria-hidden="true" />
        {/* The 4% is deliberately not here any more. Leading with two numbers
            made the offer a price comparison, which is an argument a company
            has to do arithmetic to win. The waived subscription is the part
            that is permanent and easy to understand, so it carries the banner
            on its own and the rate is a pleasant surprise in the conversation
            rather than a second thing to evaluate on a strip of black. */}
        <span>
          <strong>{left} of 100</strong> founding-organization seats left. Lock in waived
          subscription fees for life.
        </span>
        <span
          className="hidden sm:inline font-bold underline underline-offset-2 text-base sm:text-lg"
          style={{ color: "#ffd766" }}
        >
          Claim now →
        </span>
      </div>
    </Link>
  );
}
